import { useMemo }            from 'react';
import { Dispatch }           from "redux";
import { connect }            from 'react-redux';
import StarIcon               from '@mui/icons-material/Star';
import StarBorderIcon         from '@mui/icons-material/StarOutline';
import Tooltip                from '@mui/material/Tooltip';
import HeartIcon              from '@mui/icons-material/Favorite';
import QuizIcon               from '@mui/icons-material/Quiz';
import dice                   from 'images/dice.png';
import weights                from 'images/weights.png';
import { words }              from 'utils/dictionary';
import { makeStyles }         from 'makeStyles';
import { objType }            from 'types';
import { ActionTypes }        from 'actions/types';
import { SET_SELECTED_APP }   from 'actions/contentActions';
import { reducerType }        from 'reducer';

const ttprops = { 
  tooltip: { 
    dir: 'rtl',
    sx: { 
      fontSize:   16,
      textAlign: 'right'
    }
  } 
 }

const useStyles = makeStyles()(() => ({
    root: {
       height:         30,
       display:        'flex',
       alignItems:     'center',
       justifyContent: 'space-between',
    },
    star: {
      marginRight: 10,
      color:       '#FFF',
      cursor:      'pointer',
    },
    heartIcon: {
      transform: 'translate(7px, 0px)',
      color:     '#FFF',
    },
    invisibleStar: {
      marginRight: 10,
      color:       'transparent',
    },
    image: {
      height:             30,
      width:              30,
      backgroundRepeat:   'no-repeat',
      backgroundPosition: 'center',
      backgroundSize:     'contain',
    },
    appType: {
      width:       '100%',
      marginLeft:  7,
      marginRight: 5,
      color:       '#FFF',
    }
}))

type StarProps = {
  app:                 objType;
  id:                  string;
  lang:                string;
  showStar:            boolean;
  showHeart:           boolean;
  showScoresIcon:      boolean;
  disabled:            boolean;
  guest:               boolean;
  mouseEnter:          boolean;
  Iwidth:              number;
  favoriteStatus:      number;
 // appType:             number;
  setSelectedApp:      (payload: objType) => void;
  handleFavoriteClick: (status: number, id: string) => void;

}

const Star: React.FC<StarProps> = ({
  app,
  id,
  lang,
  showStar,
  showHeart,
  showScoresIcon,
  disabled,
  guest,
  mouseEnter,
  Iwidth,
  favoriteStatus,
  //appType,
  setSelectedApp,
  handleFavoriteClick
}) => {


  const { classes } = useStyles();

  const [dice_, weights_, toolTipText] = useMemo(() => {

    const aType = !!app.appType ? app.appType : app.app_type
    
    const diceIcon    = aType === 1;
    const weightsIcon = aType === 2;
    
    return[
      diceIcon, 
      weightsIcon,
      diceIcon ? `${ words['game'][lang] }` : weightsIcon ? `${ words['practice'][lang] }` : ''
    ]
  },[app, lang])


  const showScores = () => {
    setSelectedApp(app);
    import("functions/actions/go_to_score_page").then(func => {
      func.goToScorePage()
    });
  } 

  return (
    <div 
       className = { classes.root }
       style     = {{
          maxWidth: Iwidth,
          minWidth: Iwidth
       }}
    >
       {
         !guest && !disabled
         &&
         <>
            {
              showStar
              &&
              <StarIcon 
                  className = { classes.star }
                  style     = {{ fontSize: 22 }}
                  onClick   = { () => { handleFavoriteClick(favoriteStatus, id) }}
              />
            }  
            {
              !showStar && mouseEnter
              &&
              <StarBorderIcon 
                  className = { classes.star }
                  style     = {{ fontSize: 22 }}
                  onClick   = { () => { handleFavoriteClick(favoriteStatus, id) }}
              />
            }  
            {
              !showStar && !mouseEnter && <StarBorderIcon className = { classes.invisibleStar }/>
            }  
         </> 
       }
       {     
          (!!app.appType || !!app.app_type) &&
          <Tooltip 
             title           = { toolTipText } 
             placement       = "top"
             componentsProps = { ttprops }
          >
             <div className = { classes.appType }>
                { dice_    && <div className = { classes.image } style = {{ backgroundImage: `url(${ dice })` }}/> }
                { weights_ && <div className = { classes.image } style = {{ backgroundImage: `url(${ weights })` }}/> }
             </div>
          </Tooltip> 
       }
       {
         showHeart &&
         <Tooltip 
            title           = { `${ words['frequentUse'][lang] }` } 
            placement       = "top"
            componentsProps = { ttprops }

         >
            <HeartIcon 
               className = { classes.heartIcon } 
               style     = {{ fontSize: 20 }}
            />
         </Tooltip> 
        }
        {
          showScoresIcon && 
          <Tooltip 
            title           = { `${ words['showScores'][lang] }` } 
            placement       = "top"
            componentsProps = { ttprops }
            onClick         = { showScores }
         >
            <QuizIcon 
               className = { classes.heartIcon } 
               style     = {{ fontSize: 20, cursor: 'pointer' }}
            />
         </Tooltip> 
        }
    </div>
  );
}



const mapStateToProps = (reducer: reducerType) => {
  return {};
}



const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  setSelectedApp: (payload: objType) => dispatch(SET_SELECTED_APP(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(Star);
